import { useLingui } from '@lingui/react/macro';
import type { MemberAgreementGroup } from '@saas/api-client';
import { useMemo } from 'react';
import { z } from 'zod';

export const AGREEMENT_GROUPS = ['BENEFIT', 'PARTNER'] as const satisfies readonly MemberAgreementGroup[];

export const agreementGroupSearchSchema = z.looseObject({
	group: z.enum(AGREEMENT_GROUPS).optional().catch(undefined),
});

type AgreementGroupItem = {
	value: MemberAgreementGroup;
	label: string;
};

export function useAgreementGroupLabels(): Record<MemberAgreementGroup, string> {
	const { t } = useLingui();
	return useMemo(() => ({ BENEFIT: t`Benefit agreements`, PARTNER: t`Partner agreements` }), [t]);
}

export function useAgreementGroupItems(): AgreementGroupItem[] {
	const labels = useAgreementGroupLabels();
	return useMemo(() => AGREEMENT_GROUPS.map((group) => ({ value: group, label: labels[group] })), [labels]);
}
